import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import todoApp from './todo/reducer';
import chatApp from './chat/reducer';
import surveyListApp from './surveyList/reducer';
import surveyDetailApp from './surveyDetail/reducer';
import staffManagementApp from './settingManagement/staffManagement/reducer';
import userManagementApp from './settingManagement/userManagement/reducer';
import companyDetailApp from './settingManagement/companyDetail/reducer';
import treatmentManagementApp from './settingManagement/treatmentManagement/reducer';
import bedManagementApp from './settingManagement/bedManagement/reducer';
import promotionManagementApp from './settingManagement/promotionManagement/reducer';
import membershipManagementApp from './settingManagement/membershipManagement/reducer';
import packageManagementApp from './settingManagement/packageManagement/reducer';
import customerManagementApp from './settingManagement/customerManagement/reducer';
import serviceFeeManagementApp from './settingManagement/serviceFeeManagement/reducer';
import inventoryManagementApp from './settingManagement/inventoryManagement/reducer';
import couponManagementApp from './settingManagement/couponManagement/reducer';

import queueManagementApp from './queueManagement/reducer';
import housekeepingManagementApp from './housekeepingManagement/reducer';
import bookingManagementApp from './bookingManagement/reducer';
import pettyCashManagementApp from './pettyCashManagement/reducer';
// เพิ่มบรรทัดนี้: Import POS Reducer
import posManagement from './posManagement/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  todoApp,
  chatApp,
  surveyListApp,
  surveyDetailApp,

  companyDetailApp,
  staffManagementApp,
  userManagementApp,
  treatmentManagementApp,
  bedManagementApp,
  promotionManagementApp,
  membershipManagementApp,
  packageManagementApp,
  customerManagementApp,
  serviceFeeManagementApp,
  inventoryManagementApp,
  couponManagementApp,

  queueManagementApp,
  housekeepingManagementApp,
  bookingManagementApp,
  pettyCashManagementApp,
  
  // เพิ่มบรรทัดนี้: รวม POS Reducer เข้าไปใน Store
  posManagement,
});

export default reducers;
